import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * Breadcrumbs component for navigation
 * @param {Object} props - Component props
 * @param {Array} props.items - Array of breadcrumb items with label and path
 */
const Breadcrumbs = ({ items, className = '' }) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();
  
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className={`flex ${className}`} aria-label={replace('Breadcrumb')}>
      <ol className="inline-flex items-center space-x-1 md:space-x-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          const key = item.path || `breadcrumb-${index}`;
          return (
            <li key={key} className="inline-flex items-center">
              {index > 0 && (
                <span className={`mx-1 ${semantic.formText} opacity-50`}>/</span>
              )}
              
              {isLast ? (
                <span className={`${semantic.contentCardHeading} font-medium`}>
                  {replace(item.label)}
                </span>
              ) : (
                <Link 
                  to={item.path} 
                  className={`${semantic.contentCardLink} hover:${semantic.contentCardLinkHover} transition-colors duration-200`}
                >
                  {replace(item.label)}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    })
  ).isRequired,
  className: PropTypes.string
};

export default Breadcrumbs;

